import { render, staticRenderFns } from "./RewardDetailsSection.vue?vue&type=template&id=c226f9de&scoped=true&"
import script from "./RewardDetailsSection.vue?vue&type=script&lang=js&"
export * from "./RewardDetailsSection.vue?vue&type=script&lang=js&"
import style0 from "./RewardDetailsSection.vue?vue&type=style&index=0&id=c226f9de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c226f9de",
  null
  
)

export default component.exports